<template>
  <div class="modal is-active">
    <div class="modal-background" @click="finishDonate"></div>
    <div class="modal-card" style="max-width: 500px;">
      <section class="modal-card-body">
        <div class="container">
          <nav class="level is-mobile">
            <div class="level-left">
              <div class="level-item">
                <h1 class="title">Donate</h1>
              </div>
            </div>
            <div class="level-right">
              <div class="select">
                <select v-model="selCur">
                  <option
                    v-for="(currency, index) in donateCurrencies"
                    :key="index"
                    >{{ currency }}</option
                  >
                </select>
              </div>
            </div>
          </nav>
          <div v-if="donateOrg" class="has-text-centered mb-4">
            <h4 class="subtitle is-4">{{ donateOrg }}</h4>
          </div>
          <div class="buttons is-centered" v-if="selCur">
            <button
              v-for="(amount, index) in donateAmounts[selCur]"
              :key="index"
              class="button is-link"
              @click="openDonate(amount)"
            >
              <money-format :value="Number(amount)" :currency-code="selCur">
              </money-format>
            </button>
            <button
              v-if="donateAmounts[selCur].length"
              class="button is-link"
              @click="openDonate(null)"
            >
              Other
            </button>
            <button v-else class="button is-link" @click="openDonate(null)">
              Donate Now
            </button>
          </div>
        </div>
        <div class="is-pulled-right mt-4">
          <img src="./../assets/images/pp_secured.png" />
        </div>
      </section>
    </div>
    <button
      class="modal-close is-large"
      aria-label="close"
      @click="finishDonate"
    ></button>
    <PaypalDialog
      v-if="showPopup"
      :currency="selCur"
      :amount="selAmount"
      @opened="finishDonate"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import PaypalDialog from "@/components/PaypalDialog.vue";
import MoneyFormat from "vue-money-format";

export default {
  name: "DonateDialog",
  components: {
    PaypalDialog,
    "money-format": MoneyFormat
  },
  mounted() {
    this.selCur = this.donateCurrency;
  },
  data: function() {
    return {
      showPopup: false,
      selCur: null,
      selAmount: null
    };
  },
  computed: {
    ...mapState("player", [
      "donateEmail",
      "donateCurrency",
      "donateOrg",
      "donateAmounts"
    ]),
    ...mapGetters("player", ["donateCurrencies"])
  },
  methods: {
    openDonate(amount) {
      this.selAmount = amount;
      this.showPopup = true;
    },
    finishDonate() {
      this.showPopup = false;
      this.$emit("done");
    }
  }
};
</script>

<style scoped lang="scss"></style>
